import { defineComponent as _defineComponent } from 'vue'
import CardTitle from '@/components/card-title.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'reward-header',
  props: {
  amount: { type: Number, default: 10 },
},
  setup(__props) {

const props = __props


const titleContent = computed(() => i18n('送你<span class="amount">HK$ amount </span>電子現金券', {
  amount: props.amount,
}));

return { __sfc: true,props, titleContent, CardTitle, i18n }
}

})